import styled from '@emotion/styled'

import { listReset } from '../../../common/Mixins'
import media from '../../../common/MediaQueries'
import { iconBounceAnimation } from '../../../common/Animations'

export const WebtraderMediaStyled = styled.div``

export const WebtraderMediaContentStyled = styled.div`
  position: relative;
  max-width: 51.5rem;
  margin: 0 auto;
`

export const WebtraderMediaBoxStyled = styled.div`
  position: relative;
  max-height: 38.625rem;
  padding-top: 75%;
`

export const WebtraderMediaBgStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  > div {
    height: 100%;
  }
`

export const WebtraderMediaIconsListStyled = styled.ul`
  ${listReset}
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const WebtraderMediaIconsListItemStyled = styled.li`
  height: 2rem;
  width: 2rem;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 50%;
  animation: ${iconBounceAnimation} 1s ease-in-out infinite;

  > * {
    padding: 0.375rem;
  }

  &:nth-child(1) {
    position: absolute;
    right: 12%;
    top: 12%;
    animation-delay: 0.1s;
    > * {
      padding: 0;
    }
  }
  &:nth-child(2) {
    position: absolute;
    top: 50%;
    right: 10%;
    animation-delay: 0.2s;
  }
  &:nth-child(3) {
    position: absolute;
    top: 80%;
    right: 16%;
    animation-delay: 0.3s;
  }
  &:nth-child(4) {
    position: absolute;
    top: 78%;
    left: 18%;
    animation-delay: 0.4s;
  }
  &:nth-child(5) {
    position: absolute;
    top: 50%;
    animation-delay: 0.5s;
    > * {
      padding: 0;
    }
  }
  &:nth-child(6) {
    position: absolute;
    top: 10%;
    left: 20%;
    animation-delay: 0.6s;
  }
  &:nth-child(7) {
    position: absolute;
    top: 8%;
    right: 38%;
    animation-delay: 0.7s;
  }

  @media ${media.phone} {
    width: 4rem;
    height: 4rem;
  }

  @media ${media.tablet} {
    &:nth-child(1) {
      top: 20%;
      right: -1.5%;
    }
    &:nth-child(2) {
      top: calc(50% - 2rem);
      right: -6%;
    }
    &:nth-child(3) {
      top: calc(70% - 2rem);
      right: -6%;
    }
    &:nth-child(4) {
      top: calc(75% - 2rem);
      left: -1%;
    }
    &:nth-child(5) {
      top: calc(50% - 2rem);
      left: -10%;
    }
    &:nth-child(6) {
      top: calc(25% - 2rem);
      left: 1.5%;
    }
    &:nth-child(7) {
      top: calc(17% - 2rem);
      left: 32.5%;
    }
  }
`
